'use client';

import { useEffect, useState } from 'react';
import s from './TelecomCommandCentre.module.css';
import { useTranslation } from '@/hooks/useTranslation';
import { formatInt } from '@/lib/formatDate';

const TICKER_ITEMS = [
  { letter: 'R', text: 'No network since 2hrs in Andheri', handle: '@rajesh_k', tag: 'Outage', tagLevel: 'high' },
  { letter: 'P', text: 'Wrong bill charged for data pack', handle: '@priya_m', tag: 'Billing', tagLevel: 'med' },
  { letter: 'A', text: 'Want to port to competitor ASAP', handle: '@amit_s', tag: 'Port', tagLevel: 'high' },
  { letter: 'S', text: '5G speed slower than 4G promised', handle: '@suresh_v', tag: 'Network', tagLevel: 'med' },
];

function tagClass(level) {
  if (level === 'high') return `${s.tag} ${s.tagHigh}`;
  if (level === 'med') return `${s.tag} ${s.tagMed}`;
  return s.tag;
}

export default function TelecomCommandCentre() {
  const { t } = useTranslation();
  const [mentions, setMentions] = useState(2847);

  useEffect(() => {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return undefined;

    const id = window.setInterval(() => {
      setMentions((n) => n + Math.floor(Math.random() * 4) + 1);
    }, 1900);

    return () => window.clearInterval(id);
  }, []);

  return (
    <div className={s.wrap}>
      <article className={s.card} aria-label={t('industries_telecom.command_centre_label')}>
        <header className={s.cardHead}>
          <span className={s.liveDot} aria-hidden="true" />
          <span className={s.liveTag}>{t('industries_telecom.live')}</span>
          <span className={s.cardTitle}>{t('industries_telecom.command_centre_title')}</span>
        </header>

        <div className={s.kpiRow}>
          <div className={s.kpi}>
            <span className={s.kpiVal}>{formatInt(mentions)}</span>
            <span className={s.kpiLbl}>{t('industries_telecom.kpi_live_mentions')}</span>
          </div>
          <div className={s.kpi}>
            <span className={s.kpiVal}>142</span>
            <span className={s.kpiLbl}>{t('industries_telecom.kpi_open_tickets')}</span>
          </div>
          <div className={s.kpi}>
            <span className={s.kpiVal}>4.2m</span>
            <span className={s.kpiLbl}>{t('industries_telecom.kpi_avg_frt')}</span>
          </div>
        </div>

        <div className={s.sentimentRow}>
          <div className={s.bars}>
            <div className={s.barRow}>
              <span className={s.barLbl}>{t('industries_telecom.sentiment_positive')}</span>
              <div className={s.barTrack}>
                <div className={clsxBar(s.barFill, s.barGrow)} style={{ '--bar-w': '42%', background: 'var(--status-success-dot)' }} />
              </div>
            </div>
            <div className={s.barRow}>
              <span className={s.barLbl}>{t('industries_telecom.sentiment_neutral')}</span>
              <div className={s.barTrack}>
                <div className={clsxBar(s.barFill, s.barGrow)} style={{ '--bar-w': '33%', background: 'var(--text-muted)' }} />
              </div>
            </div>
            <div className={s.barRow}>
              <span className={s.barLbl}>{t('industries_telecom.sentiment_negative')}</span>
              <div className={s.barTrack}>
                <div className={clsxBar(s.barFill, s.barGrow)} style={{ '--bar-w': '25%', background: 'var(--danger, #E8543E)' }} />
              </div>
            </div>
          </div>
          <div className={s.donutWrap} aria-hidden="true">
            <svg viewBox="0 0 80 80" className={s.donut}>
              <circle cx="40" cy="40" r="30" fill="none" stroke="var(--border-light)" strokeWidth="8" />
              <circle
                className={s.donutArc}
                cx="40" cy="40" r="30" fill="none"
                stroke="var(--brand)" strokeWidth="8"
                strokeDasharray="188.5" strokeDashoffset="47"
                strokeLinecap="round"
                transform="rotate(-90 40 40)"
              />
            </svg>
            <span className={s.donutVal}>75%</span>
            <span className={s.donutLbl}>{t('industries_telecom.sla_met')}</span>
          </div>
        </div>

        <div className={s.tickerWrap}>
          <p className={s.tickerLabel}>{t('industries_telecom.incoming_complaints')}</p>
          <div className={s.tickerViewport}>
            <ul className={s.ticker}>
              {[...TICKER_ITEMS, ...TICKER_ITEMS].map((item, i) => (
                <li key={i} className={s.tickerItem}>
                  <span className={s.avatar}>{item.letter}</span>
                  <div className={s.tickerText}>
                    <span className={s.tickerMsg}>{item.text}</span>
                    <span className={s.tickerHandle}>{item.handle}</span>
                  </div>
                  <span className={tagClass(item.tagLevel)}>{item.tag}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </article>

      <div className={s.chipLight} aria-hidden="true">
        <span className={s.chipTitle}>{t('industries_telecom.chip_churn_title')}</span>
        <span className={s.chipSub}>{t('industries_telecom.chip_churn_sub')}</span>
      </div>
      <div className={s.chipDark} aria-hidden="true">
        <span className={s.chipTitle}>{t('industries_telecom.chip_agentiq_title')}</span>
        <span className={s.chipSub}>{t('industries_telecom.chip_agentiq_sub')}</span>
      </div>
    </div>
  );
}

function clsxBar(...parts) {
  return parts.filter(Boolean).join(' ');
}
